// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"95":"css/app.6692","8103":"css/admin-app.6692"}[chunkId] + ".css";
};